import {ComponentType} from "react";
import {css} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: ComponentType<IIcon>;
    label: string;
}

export const GalleryModalTabsTitle = (props: IProps) => {
    const {icon: Icon, label} = props;

    return (
        <div className={holderStyle}>
            <Icon size="2" className={desktopIconStyle} />
            {label}
        </div>
    );
};

const holderStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "1 0 100%",

    md: {
        px: 0
    }
});

const desktopIconStyle = css({
    mr: 2,
    display: "none",

    md: {
        display: "block"
    }
});
import {ComponentType} from "react";
import {css} from "@panda/css";

import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: ComponentType<IIcon>;
    label: string;
}

export const GalleryModalTabsTitle = (props: IProps) => {
    const {icon: Icon, label} = props;

    return (
        <div className={holderStyle}>
            <Icon size="2" className={desktopIconStyle} />
            {label}
        </div>
    );
};

const holderStyle = css({
    display: "flex",
    alignItems: "center",
    flex: "1 0 100%",

    md: {
        px: 0
    }
});

const desktopIconStyle = css({
    mr: 2,
    display: "none",

    md: {
        display: "block"
    }
});
